module.exports = __webpack_public_path__ + "static/media/margherita.2da51d5f.jpg";